import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

// Notifications are addressed by (email, recipientType) — the backend resolves
// that pair to the recipient's own id in the right collection, so the frontend
// never carries that id around (see NotificationService.js).
//
// Header.jsx worked this out inline to decide which bell to render; the
// Notifications page needs exactly the same answer, so the logic lives here
// once rather than drifting between the two.
export const useNotificationRecipient = () => {
  const { user, hasPermission } = useAuth();

  return useMemo(() => {
    const userData = user?.user || user;
    const email = userData?.email || null;

    const isStudent = userData?.profiles?.some((p) => (p.label || p.name) === "Student");
    // A permission check rather than a profile-label match, since a trainer's
    // profile label isn't guaranteed to literally be "Trainer" — same
    // detection AdminCalendar.jsx and Header.jsx use.
    const isTrainer =
      !isStudent &&
      (hasPermission("trainer-calendar", "view", "lms") ||
        hasPermission("trainer-calender", "view", "lms"));

    let recipientType = null;
    if (isStudent) recipientType = "student";
    else if (isTrainer) recipientType = "trainer";

    return { email, recipientType, isStudent, isTrainer };
  }, [user, hasPermission]);
};
